import React from 'react';
import autoBind from 'react-autobind';
import { Row, Col, Alert, Button, Progress, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import ApplicationItemTileSubComponent from './ApplicationItemTileSubComponent';
import CustomCollapse from '../../../../commonComponents/CustomCollapse';

export default class ApplicationSectionsSubComponent extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      isConfirmVisible: false
    };
  }

  _handleRemoveApplication = () => {
    this.setState({ isConfirmVisible: true });
  };

  _confirmRemoveApplication = () => {
    this.setState({ isConfirmVisible: false });
    this.props.actions.onRemoveApplication();
  };

  _cancelRemoveApplication = () => {
    this.setState({ isConfirmVisible: false });
  };

  render() {
    const { sections, applicationProcess } = this.props;
    const { isConfirmVisible } = this.state;
    const isRemovable = applicationProcess.type === 'NEW' && applicationProcess.state !== 'APPROVED';
    return (
      <>
        {sections.flat().map((section, i) => {
          if (section.tiles?.length < 1) {
            return null;
          }

          let progressPercentage = null;
          let filledItems = 0;
          if (section.metadata?.progress) {
            filledItems = section.metadata.progress.requiredCount - section.metadata.progress.missingCount;
            progressPercentage = Math.floor((filledItems * 100) / section.metadata.progress.requiredCount);
          }

          return (
            <CustomCollapse
              visible
              key={i}
              title={section.title}
              description={section.description}
              extraActions={() => (
                <>
                  {i === 0 && (
                    <div style={{ display: "flex", gap: 8 }}>
                      <Button
                        key="downloadapplication"
                        type="primary"
                        onClick={this.props.actions.onDownloadApplication}
                      >
                        Download Application
                      </Button>
                      <Button
                        key="removeapplication"
                        type="primary"
                        icon={<DeleteOutlined />}
                        style={{ fontSize: 12 }}
                        disabled={!isRemovable}
                        onClick={this._handleRemoveApplication}
                      />
                    </div>

                  )}

                  {progressPercentage != null && (
                    <Progress
                      type="circle"
                      width={70}
                      style={{ marginLeft: 10 }}
                      percent={progressPercentage}
                      format={() => `${filledItems}/${section.metadata.progress.requiredCount}`}
                    />
                  )}
                </>
              )}
            >
              {this._renderAlert(section)}
              {this._renderSectionTiles(section)}
            </CustomCollapse>
          );
        })}

        <Modal
          title="Confirm Removal"
          visible={isConfirmVisible}
          onOk={this._confirmRemoveApplication}
          onCancel={this._cancelRemoveApplication}
          okText="Confirm"
          cancelText="Cancel"
        >
          Attention - this will remove the application and all files uploaded by the user. This operation cannot be reversed. Confirm?
        </Modal>
      </>
    );
  }

  _renderAlert(section) {
    const { alert } = section;

    if (!alert) {
      return null;
    }

    return (
      <Alert style={{ marginBottom: 16 }} message={alert.title} description={alert.description} type={alert.type} />
    );
  }

  _renderSectionTiles(section) {
    const { optionalTiles } = this.props;
    const isAdmin = this.props.app.isAdmin();

    return this._separateTilesByRows(section.tiles).map((tiles, index) => (
      <Row gutter={24} key={String(index)} style={{ marginBottom: 24 }}>
        {tiles.map((tile) => {
          let disabled = tile.disabled || tile.isDisabled;
          let tooltip = tile.tooltip;

          const isTileSkipped = optionalTiles?.find((skippedTile) => skippedTile.id === tile.id);
          if (isTileSkipped) {
            tooltip = isTileSkipped.message;
          }

          if (disabled && !isAdmin) {
            return null;
          }

          return (
            <Col xs={24} sm={12} md={12} lg={6} key={tile.id} className="tile-column">
              <ApplicationItemTileSubComponent
                tile={tile}
                disabled={disabled}
                skip={isTileSkipped}
                tooltip={tooltip}
                onUpload={() => this.props.actions.onUpload(tile)}
                onResubmit={this.props.actions.onResubmit}
                onDelete={this.props.actions.onDelete}
                onDownload={this.props.actions.onDownload}
                onPreview={this.props.actions.onPreview}
                onEdit={this.props.actions.onEdit}
                onDeleteForeignItem={this.props.actions.onDeleteForeignItem}
                certificationProcess={this.props.certificationProcess}
                applicationProcess={this.props.applicationProcess}
                foreignItems={this.props.foreignItems}
                certificationSpecs={this.props.certificationSpecs}
              />
            </Col>
          );
        })}
      </Row>
    ));
  }

  _separateTilesByRows(tiles) {
    const rows = [];

    tiles.forEach((tile, index) => {
      const row = Math.floor(index / 4);
      if (!rows[row]) rows[row] = [];

      rows[row].push(tile);
    });

    return rows;
  }
}
